import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AnswerRequest } from '@app/models/questionnaire/answerRequest.model';
import { AnswerResponse } from '@app/models/questionnaire/answerResponse.model';
import { CompleteResponse } from '@app/models/questionnaire/completeResponse.model';
import { CheckPaymentModel } from '@app/models/questionnaire/payment.models';
import { QuestionnaireModel } from '@app/models/questionnaire/questionnaire.model';
import { QuestionsModel } from '@app/models/questionnaire/questions.model';
import { QuestionStatusModel } from '@app/models/questionnaire/questionStatus.model';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

import { AppConfig } from '@app/app.config';
import { CurrentQuestionnaireService } from './current-questionnaire.service';

@Injectable()
export class QuestionnaireService {
  status: Subject<QuestionStatusModel> = new Subject<QuestionStatusModel>();
  statusOverride: Subject<number> = new Subject<number>();
  paymentData: BehaviorSubject<string> = new BehaviorSubject<string>('/');
  paymentUrl: Observable<string>;

  constructor(private http: HttpClient, private currentQuestionnaire: CurrentQuestionnaireService) {
    this.paymentUrl = this.paymentData.asObservable();
  }

  getCurrentQuestionnaire(): Observable<QuestionnaireModel> {
    var url = AppConfig.ApiUrl + 'questionnaire/' + this.currentQuestionnaire.get();
    return this.http
      .get<QuestionnaireModel>(url)
      .catch(err => Observable.throw(err.error as QuestionnaireModel));
  }

  getQuestions(): Observable<QuestionsModel> {
    var url = AppConfig.ApiUrl + `questionnaire/${this.currentQuestionnaire.get()}/questions`;
    return this.http
      .get<QuestionsModel>(url)
      .catch(err => Observable.throw(err.error as QuestionsModel));
  }

  getQuestionnaireStatus(): Observable<QuestionStatusModel> {
    var url = AppConfig.ApiUrl + `questionnaire/${this.currentQuestionnaire.get()}/status`;
    return this.http
      .get<QuestionStatusModel>(url)
      .mergeMap(result => {
        this.status.next(result);
        return Observable.of(result);
      })
      .catch(err => Observable.throw(err as QuestionStatusModel));
  }

  submitAnswer(questionId: number, model: AnswerRequest): Observable<AnswerResponse> {
    var url =
      AppConfig.ApiUrl + `questionnaire/${this.currentQuestionnaire.get()}/answer/${questionId}`;
    return this.http
      .put<AnswerResponse>(url, model)
      .catch(err => Observable.throw(err.error as AnswerResponse));
  }

  submitCompleteQuestionnaire(): Observable<CompleteResponse> {
    var url = AppConfig.ApiUrl + `questionnaire/${this.currentQuestionnaire.get()}/complete`;
    return this.http
      .post<CompleteResponse>(url, null)
      .catch(err => Observable.throw(err.error as CompleteResponse));
  }

  requestPaymentGateway(setPaymentOnly?: boolean) {
    this.checkPayment().subscribe(res => {
      let queryString = new HttpParams()
        .set('product', 'myunichoices')
        .set('start', '1')
        .set('return_url', window.location.origin + '/registration-complete')
        .set('uuid', this.currentQuestionnaire.get())
        .toString();
      let paymentUrl = encodeURI(`${res.paymentUrl}?${queryString}`);

      if (setPaymentOnly == true) {
        this.paymentData.next(paymentUrl);
      } else {
        window.location.href = paymentUrl;
      }
    });
  }

  checkPayment(): Observable<CheckPaymentModel> {
    let url = AppConfig.ApiUrl + `questionnaire/${this.currentQuestionnaire.get()}/payment`;
    return this.http.get<CheckPaymentModel>(url).catch(err => Observable.throw(err.error));
  }
}

export class AnswerStore {
  id: number;
  data: AnswerRequest;
}



// WEBPACK FOOTER //
// ./src/app/services/questionnaire.service.ts